import type { StateCreator } from 'zustand';
import type { PrescriptionAssistantSliceType } from '../types';

export const setIsPostingPrescription: StateCreator<
  PrescriptionAssistantSliceType,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  (value: boolean) => void
> = (set) => (value) =>
  set(
    (state) => {
      state.prescriptionAssistant.prescriptionSubmitState.isPostingPrescription = value;
    },
    false,
    'prescriptionSubmit/setIsPostingPrescription',
  );
